const NAVBAR_DATA = [
  { name: 'About', number: '1', link: 'about' },
  { name: 'Expertise', number: '2', link: 'expertise' },
  // { name: 'Career', number: '3', link: 'career' },
  { name: 'Locations', number: '4', link: 'locations' },
  { name: 'Cooperation', number: '5', link: 'cooperation' },
];

export default NAVBAR_DATA;
